import OrderMobileRouters from "./components/OrderMobile.Routers";

const OrderCreateMobile = () => <OrderMobileRouters />;

export default OrderCreateMobile;
